import { ComponentProps } from "react";
import { keyframes, styled } from "~/application/theme";

export type SpinnerProps = ComponentProps<typeof Spinner>;

const animSpin = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" },
});

export const Spinner = styled("span", {
  // Reset
  boxSizing: "border-box",
  display: "inline-block",

  // Custom
  position: "relative",
  textIndent: "-9999em",
  fontSize: "0.5rem",
  borderStyle: "solid",

  transform: "translateZ(0)",
  animation: `${animSpin} 0.8s infinite linear`,
  borderRadius: "$circular",
  flexShrink: 0,

  variants: {
    size: {
      xs: {
        width: "$4",
        height: "$4",
        borderWidth: "2px",
      },
      sm: {
        width: "$6",
        height: "$6",
        borderWidth: "3px",
      },
      md: {
        width: "$11",
        height: "$11",
        borderWidth: "6px",
      },
      lg: {
        width: "$40",
        height: "$40",
        borderWidth: "10px",
      },
    },
    variant: {
      primary: {
        borderColor: "$primary-600",
        borderTopColor: "transparent",
      },
      white: {
        borderColor: "$neutrals-white",
        borderTopColor: "transparent",
      },
    },
  },

  defaultVariants: {
    size: "md",
    variant: "primary",
  },
});

Spinner.displayName = "Spinner";
